import { useMemo } from "react";
import { useAuthStore } from "../store/useAuthStore";

export const useAuth = () => {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  const logout = useAuthStore((s) => s.logout);
  const isHashKeyUser = useAuthStore((s) => s.isHashKeyUser);

  const isAuthenticated = useMemo(() => !!token, [token]);
  const mongoId = useMemo(() => user?.mongo_id, [user?.mongo_id]);
  const planIds = useMemo(() => user?.plan_ids || [], [user?.plan_ids]);
  const isHashKey = useMemo(() => isHashKeyUser(), [isHashKeyUser]);

  return {
    user,
    token,
    logout,
    isAuthenticated,
    mongoId,
    planIds,
    isHashKey,
  };
};
